import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Router from "./Router";

const isResizeObserverLoopError = (message) =>
  message === "ResizeObserver loop completed with undelivered notifications." ||
  message === "ResizeObserver loop limit exceeded";

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverLoopError(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true,
);

window.addEventListener("unhandledrejection", (event) => {
  if (isResizeObserverLoopError(event.reason?.message || event.reason)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
